import useEntity from "../../hooks/useTreeMarking";
import TreeMarkingDetail from "../../components/treeMarking/TreeMarkingDetail/TreeMarkingDetail";
import TreeMarkingScoped from "../../components/treeMarking/TreeMarkingDetail/TreeMarkingScoped";
import TreeMarkingTabs from "../../components/treeMarking/TreeMarkingDetail/TreeMarkingTabs";
import { useGetTreeMarkingQuery } from "../../apis/TreeMarking.api";
import { PrimaryTreeMarking } from "../../types/models/TreeMarking";
import React from "react";
import {Delete, Edit} from "@mui/icons-material";
import {Box, Paper, Stack, Button} from "@mui/material";
import {NavLink, useParams, useSearchParams} from "react-router";
import {useStateSession} from "../../../hooks/useAuth";
import {useTitle} from 'react-use';
import { Trans } from "@lingui/react/macro";
import { t } from "@lingui/core/macro";

const TreeMarkingDetailPage = () => {

    useTitle(t`Details Tree Marking`);

    const session = useStateSession()
    const [searchParams] = useSearchParams();
    const scoped = searchParams.get("scoped");
    const { treeMarkingId: id } = useParams();

    const { data, refetch } = useGetTreeMarkingQuery(PrimaryTreeMarking.fromPath(id))
    const { deleteTreeMarking } = useEntity();

    const onDelete = React.useCallback((e: any) => {
        e.stopPropagation()
        deleteTreeMarking(data, '..')
    }, [data, deleteTreeMarking])

    if (id === 'scoped') {
        return (<TreeMarkingScoped/>)
    }

    return (
        <Box data-testid="TreeMarking-details">
            { data && <Paper sx={ { padding: "2em" } }>
                <TreeMarkingDetail data={data} refetch={refetch} scoped={scoped}/>
                <Stack direction="row" spacing={1} sx={{ justifyContent: "center", marginTop: "2em"}}>
                    
                    { (session.hasPermission(
            data.scopeGroupId,
            'applications/timber/entities/TreeMarkings/update/view'
        ) ||
false) &&
                        <Button size="small" variant="outlined" data-testid="TreeMarking-edit-button" startIcon={<Edit />}
                                component={NavLink}
                                to="edit"
                                relative="route"
                                viewTransition={true}
                        >
                            <Trans>Edit</Trans>
                        </Button>
                    }
                    { (session.hasPermission(
            data.scopeGroupId,
            'applications/timber/entities/TreeMarkings/delete/view'
        ) ||
false) &&
                        <Button size="small" color="error" variant="outlined" data-testid="TreeMarking-delete-button" startIcon={<Delete />}  onClick={(e) => onDelete(e)}>
                            <Trans>Delete</Trans>
                        </Button>
                    }
                </Stack>
            </Paper>}

            { data && <Stack direction="row" spacing={1} sx={ { marginTop: "2em" } }>
                <TreeMarkingTabs data={data} />
            </Stack>}
        </Box>
    )
}

export default TreeMarkingDetailPage;
